import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  AccountReceivableVoidInput,
  AccountReceivableMutationInput,
  AccountReceivableUpdateInput,
  AccountReceivableModel,
} from './model';

export function useCreateAccountReceivable(
  options?: UseMutationOptions<
    ApiResult<AccountReceivableModel>,
    ApiError,
    AccountReceivableMutationInput
  >,
): UseMutationResult<
  ApiResult<AccountReceivableModel>,
  ApiError,
  AccountReceivableMutationInput
> {
  return useMutation<
    ApiResult<AccountReceivableModel>,
    ApiError,
    AccountReceivableMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'account-receivables',
      method: 'POST',
      body,
      classType: AccountReceivableModel,
    });
  }, options);
}

export function useUpdateAccountReceivable(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    AccountReceivableUpdateInput
  >,
): UseMutationResult<ApiResult<any>, ApiError, AccountReceivableUpdateInput> {
  return useMutation<ApiResult<any>, ApiError, AccountReceivableUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `account-receivables/${body.id}`,
        method: 'PUT',
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidAccountReceivable(
  options?: UseMutationOptions<
    ApiResult<{ message: string }>,
    ApiError,
    AccountReceivableVoidInput
  >,
): UseMutationResult<
  ApiResult<{ message: string }>,
  ApiError,
  AccountReceivableVoidInput
> {
  return useMutation<
    ApiResult<{ message: string }>,
    ApiError,
    AccountReceivableVoidInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `account-receivables/${body.id}/void`,
      method: 'PATCH',
    });
  }, options);
}
